import cx from 'classix';
import { ReactNode } from 'react';

type TagSizes = 'sm' | 'md' | 'lg';

type TagProps = {
  size: TagSizes;
  children: ReactNode;
  leadNumber?: number;
  tailNumber?: number;
  variant: 'badge' | 'circle';
  color?: 'default' | 'accent';
};

const NumberTag = (props: TagProps) => {
  const { children, leadNumber, tailNumber, size = 'md', color = 'default' } = props;

  const hasLeadNumber = leadNumber !== undefined;
  const hasTailNumber = tailNumber !== undefined;
  return (
    <div
      className={cx(
        'font-sans text-sm tracking-wider rounded-md focus:outline-none inline-flex gap-[3px] justify-center items-center border',
        size === 'sm' && 'py-[3px] px-1',
        // I'm leaving these commented out for time being, as the below matches the DS system component, however
        // first implemenation in Matching Guidance does not include
        // size === 'sm' && !hasTailNumber && !hasLeadNumber && 'px-2',
        // size === 'sm' && hasTailNumber && !hasLeadNumber && 'pr-1 pl-2',
        // size === 'sm' && !hasTailNumber && hasLeadNumber && 'pr-2 pl-1',
        // size === 'sm' && hasTailNumber && hasLeadNumber && 'pr-0.5 pl-[5px]',

        size === 'md' && 'py-0.5',
        size === 'md' && !hasTailNumber && !hasLeadNumber && 'px-[9px]',
        size === 'md' && hasTailNumber && !hasLeadNumber && 'pr-1 pl-[9px]',
        size === 'md' && !hasTailNumber && hasLeadNumber && 'pr-[9px] pl-1',
        size === 'md' && hasTailNumber && hasLeadNumber && 'px-1',

        size === 'lg' && 'py-1',
        size === 'lg' && !hasTailNumber && !hasLeadNumber && 'px-2.5',
        size === 'lg' && hasTailNumber && !hasLeadNumber && 'pr-1 pl-2.5',
        size === 'lg' && !hasTailNumber && hasLeadNumber && 'pr-2.5 pl-1',
        size === 'lg' && hasTailNumber && hasLeadNumber && 'px-1',

        (size === 'sm' || size === 'md') && 'min-h-6',
        size === 'lg' && 'h-7',

        color === 'accent' ? 'border-accent-500 bg-warning-100' : 'border-gray-100 bg-gray-50',
      )}
    >
      {leadNumber && (
        <div
          className={cx(
            'px-[6px] rounded-[3px]',
            color === 'accent' ? 'bg-accent-600' : 'bg-gray-100',
          )}
        >
          {leadNumber}
        </div>
      )}
      {children}
      {tailNumber && <div>{tailNumber}</div>}
    </div>
  );
};

export default NumberTag;
